import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getRankList } from '../../services'
import { RankQueryKeys } from '@/modules/manage-rank/keys'
import { GetRankRequest, GetRankResponse } from '@/modules/manage-rank/type'
export default function useQueryGetRankList(
	payload: GetRankRequest,
	props?: UseBaseQueryOptions<GetRankResponse>,
) {
	return useQuery({
		queryKey: [RankQueryKeys.GetRankList, payload],
		queryFn: () => getRankList(payload),
		...props,
	})
}
